import {
  Component,
  Input,
  ViewEncapsulation,
  SimpleChanges
} from "@angular/core";


@Component({
  selector: "adp-banner",
  templateUrl: "./adp-banner.component.html",
  styleUrls: ["./adp-banner.component.scss"],
  encapsulation: ViewEncapsulation.None
})


export class ADPBannerComponent {
  @Input() labelKey: string;
  @Input() messageType: BannerMessageType;
  @Input() innerHTML: string;
  showBanner: boolean = true;

  close() {
    this.showBanner = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showBanner  = true;
  }
}

export declare type BannerMessageType = 'error' | 'success' | 'warning' | 'blocked';

